import { Injectable } from '@angular/core';
import { ApiRequestService } from '../../../shared/api-request.service';

@Injectable({
    providedIn: 'root'
})
export class DataTransferService {

    constructor(private api: ApiRequestService) {}

    triggerExport(accountId: number): Promise<any> {
        return this.api.makeRequest('post', `v2/admin/accounts/${accountId}/data-transfer/export`);
    }

    triggerImport(accountId: number, file: File): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.api.makeRequest('post', `v2/admin/accounts/${accountId}/data-transfer/import`, formData);
    }

    getStatus(accountId: number): Promise<any> {
        return this.api.makeRequest('get', `v2/admin/accounts/${accountId}/data-transfer/status`);
    }

    getHistory(accountId: number, params: any = {}): Promise<any> {
        return this.api.makeRequest('get', `v2/admin/accounts/${accountId}/data-transfer/history`, {}, params);
    }

    getDownloadInfo(accountId: number, operationId: number): Promise<any> {
        return this.api.makeRequest('get', `v2/admin/accounts/${accountId}/data-transfer/download/${operationId}`);
    }
}
